(() => {
  const ROOT = '[data-ss]';
  const READY = 'data-ss-ready';

  const init = (root) => {
    if (!root || root.hasAttribute(READY)) return;
    if (typeof root._ssCleanup === 'function') root._ssCleanup();

    const slides = Array.from(root.querySelectorAll('[data-ss-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-ss-dot]'));
    const prev = root.querySelector('[data-ss-prev]');
    const next = root.querySelector('[data-ss-next]');
    if (slides.length < 2) return;

    root.setAttribute(READY, '');

    const intervalMs = Math.max(2000, Number(root.dataset.ssInterval) || 5000);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    if (index < 0) index = 0;
    let timer = null;
    let inView = true;

    const setIndex = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      if (reduceMotion || root.dataset.ssAutoplay !== 'true' || !inView) return;
      if (document.hidden) return;
      timer = setInterval(() => setIndex(index + 1), intervalMs);
    };

    const go = (nextIndex) => {
      setIndex(nextIndex);
      start();
    };

    const onPrev = () => go(index - 1);
    const onNext = () => go(index + 1);
    const onDot = (event) => {
      const i = dots.indexOf(event.currentTarget);
      if (i < 0) return;
      go(i);
    };

    const onFocusOut = (event) => {
      if (!root.contains(event.relatedTarget)) start();
    };

    const onVisibility = () => {
      if (document.hidden) stop();
      else start();
    };

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    dots.forEach((dot) => dot.addEventListener('click', onDot));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', onVisibility);

    let io = null;
    if (typeof IntersectionObserver !== 'undefined') {
      io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;
          inView = entry.isIntersecting;
          if (inView) start();
          else stop();
        },
        { threshold: 0.15 }
      );
      io.observe(root);
    }

    root._ssCleanup = () => {
      stop();
      if (io) {
        io.disconnect();
        io = null;
      }
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      dots.forEach((dot) => dot.removeEventListener('click', onDot));
      root.removeEventListener('mouseenter', stop);
      root.removeEventListener('mouseleave', start);
      root.removeEventListener('focusin', stop);
      root.removeEventListener('focusout', onFocusOut);
      document.removeEventListener('visibilitychange', onVisibility);
      root._ssCleanup = null;
      root.removeAttribute(READY);
    };

    setIndex(index);
    start();
  };

  const scan = () => {
    document.querySelectorAll(ROOT).forEach(init);
  };

  const rescan = () => {
    document.querySelectorAll(ROOT).forEach((root) => {
      if (typeof root._ssCleanup === 'function') root._ssCleanup();
    });
    scan();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(ROOT);
    if (root && typeof root._ssCleanup === 'function') root._ssCleanup();
  });
})();
